import axiosClient from '../axiosClient';

const categoryProductAPI = {
    async getListCategory(params) {
        const url = `/category`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
};

export default categoryProductAPI;
